import { useState, useEffect, useRef } from "react";
import ProjectItem from "../components/ProjectItem";
//import { Link } from "react-router-dom";
import HMSidebar from "../components/HMSidebar";
import projectsData from "../data/projectsData";
import {Link, useNavigate} from "react-router-dom";
import emailjs from '@emailjs/browser';



const ExpandableText = ({ title, text }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const shortText = text.slice(0, 150);

    return (
        <div className="home-intro-column">
            <h2>{title}</h2>
            <p>
                {isExpanded ? text : `${shortText}...`}
                <span className="see-more-btn" onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? "Show less" : "See more"}
                </span>
            </p>
        </div>
    )
}


function Home() {
    const slides = [
        '/images/Condominium/Seresta/webp/20240820_143209_result.webp',
        '/images/Condominium/Seresta/webp/20240820_144205_result.webp',
        '/images/Commercial/Daone/Image01.webp',
        '/images/Commercial/Ara Cafe/JPEG Web Use/7M206083_HDR1.webp',
        '/images/Commercial/Ara Cafe/JPEG Web Use/7M205936_HDR1.webp',
        '/images/Commercial/Foxboro/Image01.webp',
        '/images/Commercial/Foxboro/Image19.webp',
        '/images/Landed/Glenmarie/webp/20230731_143633_result.webp',
        '/images/Landed/Glenmarie/Kit/webp/20240110_143113_result.webp',
        '/images/Condominium/The Pulse - Feilou/Image03.webp',  
        //'/images/Gallery/2023/Bukit Rahman Putra/Living/20230815_120409.jpg',
    ];
    const [currentSlide, setCurrentSlide] = useState(0);
    
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 3000);
        return () => clearInterval(interval);
    }, [slides.length]);

    /*const projectItems = [
        { image: '/images/Gallery/2023/Glenmarie/Kit/20240110_143021.jpg', title: 'Glenmarie, 01' },
        { image: '/images/Condominium/Seresta/20240820_143457.jpg', title: 'Seresta, 01' },
        { image: '/images/Condominium/MTZ/JPEG/7M203894.jpg', title: 'The Park, 02' },
        { image: '/images/Landed/TTDI/7M204445.jpg', title: 'TTDI, 01' },
     ];*/
    const projectItems = projectsData.filter((p) =>
      ['glenmarie-00', 'seresta-01', 'aracafe-01', 'foxboro-02'].includes(p.id)
    );



    const navigate = useNavigate();
    const form = useRef();
    const [formData, setFormData] = useState({
        salutation: '', name: '', email: '', contactNumber: '',
        propertyType: '', otherPropertyType: '', enquiry: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const serviceID = 'service_18mfqf2';
        const templateID = 'template_phqamrh';
        const publicKey = 'rUCdgM9MIRAjjBqyY';

        emailjs.sendForm(serviceID, templateID, form.current, publicKey)
            .then((result) => {
                navigate('/thank-you');
                /*alert('Enquiry sent successfully!');*/
                setFormData({
                    salutation: '', name: '', email: '', contactNumber: '',
                    propertyType: '', otherPropertyType: '', enquiry: ''
                });
            }, (error) => {
                console.log('FAILED...', error.text);
                alert('Failed to send enquiry.');
            });
    };



    return (
        <>
        <div className="hero">
            <div className="slideshow">
                {slides.map((slide, index) => (
                    <img
                    key={index}
                    src={slide}
                    alt={`Slide ${index}`}
                    loading={'eager'}//{index === 0 ? "eager" : "lazy"}
                    className={`slide ${index === currentSlide ? 'active' : ''}`}
                    />
                ))}
            </div>
            <div className="hero-text">
                <h1> </h1>
                <p></p> 
            </div>
        </div>



        <section className="home-intro-section">
            <div className="container">
                <h1 className="section-title">Our Service</h1>
                <div className="service-intro"> {/* Reuse service-intro for layout */}
                    <ExpandableText 
                        /*title={<>Factory<br/>Customise<br/>Cabinetry</>}*/
                        title="Customise Cabinetry"
                        text="We offer bespoke cabinetry crafted directly in our factory, allowing us to manage your project seamlessly from concept to completion. Our end-to-end service covers design development, material selection, specialised in-house woodworking, and premium finishing. With a strong emphasis on craftsmanship and durability, we deliver timeless, high-quality cabinetry tailored to enhance every details of your furniture." 
                    />
                    <ExpandableText 
                        title="Full Renovation" 
                        text="From initial design consultation to final handover, we provide a fully integrated renovation service for your entire space. Our scope includes design consultation, 3D visualisation, space planning, M&E and lighting planning, ceiling design, wall finishing, refurbishing of bathroom, colour and material coordination, and furniture specification. By overseeing every detail with precision and care, we ensure a seamless renovation experience and bring your ideal living environment to life." 
                    />
                </div>

                    {/*View more service buttom at homepage */}

            <div className="view-more-container">
                  <Link to="/service" className="view-more-services-btn" onClick={() => window.scrollTo(0, 0)}>
                    View more services <span>&rarr;</span>
                  </Link>
            </div>
            </div>
        </section>




        <section className="projects">
            
            <div className="projects-container">
                <HMSidebar />
                {/*
                <div className="projects-sidebar">
                    <h2>Projects</h2>
                    <ul>
                        <li><a href="#condominium">Condominium</a></li>
                        <li><a href="#semi-d">Semi-D</a></li>
                        <li><a href="#commercial">Commercial</a></li>
                        <li><a href="#landed">Landed</a></li>
                        <li>
                            <Link to="/gallery" className="view-all">View All</Link>
                        </li>
                    </ul>
                </div>
                */}

                <div className="project-main">
                    <div className="project-grid">
                        {projectItems.map((item) => (
                            <ProjectItem
                                key={item.id}
                                id={item.id}
                                image={item.titleImage}
                                title={item.title}
                            />
                        ))}

                        {/*<ProjectItem image="/images/Gallery/2023/Glenmarie/Kit/20240110_143021.jpg" title="Glenmarie, 01" />
                        <ProjectItem image="/images/Condominium/Seresta/20240820_143457.jpg" title="Seresta, 01" />
                        <ProjectItem image="/images/Condominium/MTZ/JPEG/7M203894.jpg" title="The Park, 02" />
                        <ProjectItem image="/images/Landed/TTDI/7M204445.jpg" title="TTDI, 01" />*/}
                    </div>
                     <div style={{ padding: '4% 0'}}>
                        <Link to="/gallery" className="view-all" onClick={() => window.scrollTo(0, 0)}
                        style={{
                            fontSize: '14px',
                            color: '#777',
                            padding: '',
                        }}
                        >
                            View More <span>&rarr;</span>
                        </Link>
                    </div>
                </div>

            </div>
        </section>


                {/*form section*/}
        <section className="home-enquiry-form">
            <h2>Enquiry Form</h2>
            <form ref={form} className="enquiry-form" onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Salutation:</label>
                    <select
                        name="salutation"
                        value={formData.salutation}
                        onChange={handleChange}
                        required>
                        <option value="">Select Salutation</option>
                        <option value="Mr.">Mr.</option>
                        <option value="Ms.">Ms.</option>
                    </select>
                </div>

                <div className="form-group">
                    <label>Name:</label>
                    <input 
                        type="text" 
                        name="name" 
                        value={formData.name} 
                        onChange={handleChange} 
                        required 
                    />
                </div>

                <div className="form-group">
                    <label>Email:</label>
                    <input 
                        type="email" 
                        name="email" 
                        value={formData.email} 
                        onChange={handleChange} 
                        required 
                    />
                </div>

                <div className="form-group">
                    <label>Contact Number:</label>
                    <input 
                        type="tel" 
                        name="contactNumber" 
                        value={formData.contactNumber} 
                        onChange={handleChange} 
                        placeholder="e.g. +6012 345 6789"
                        required 
                    />
                </div>

                <div className="form-group">
                    <label>Property Type:</label>
                    <select 
                        name="propertyType" 
                        value={formData.propertyType} 
                        onChange={handleChange} 
                        required
                    >
                        <option value="">Select Type</option>
                        <option value="Warehouse">Warehouse</option>
                        <option value="Shop lot">Shop lot</option>
                        <option value="Offices">Offices</option>
                        <option value="Condominium">Condominium</option>
                        <option value="Semi-D">Semi-D</option>
                        <option value="Bungalow">Bungalow</option>
                        <option value="others">Others</option>
                    </select>
                </div>

                {/* Conditional Text Box for 'Others' */}
                {formData.propertyType === 'others' && (
                    <div className="form-group">
                        <label>Please specify property type:</label>
                        <input 
                            type="text" 
                            name="otherPropertyType" 
                            value={formData.otherPropertyType} 
                            onChange={handleChange} 
                            required 
                        />
                    </div>
                )}

                <div className="form-group">
                    <label>Enquiry:</label>
                    <textarea 
                        name="enquiry" 
                        value={formData.enquiry} 
                        onChange={handleChange} 
                        placeholder="e.g. Which area do you cover?"
                        required 
                    />
                </div>

                    <button type="submit" className="submit-btn">Send Enquiry</button>


            </form>
        </section>         
        </>
    );
}

export default Home;
